<template>
	<h1>Hello in Support Page</h1>
</template>

<script>
export default {
	name: 'SupportPage',
}
</script>

<style scoped></style>
